// TODO: Link 때문에 여길로 오게 되었는데, 나중에 Link가 mildang-ui로 이전 필요
import { create } from 'zustand';

interface SyncStudyStoreState {
  sync: boolean;
  setSync: (sync: boolean) => void;
}

export const useSyncStudyStore = create<SyncStudyStoreState>()((set) => ({
  sync: false,
  setSync: (sync) => set({ sync }),
}));
